import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPolygonPurpleSizeS from './IconPolygonPurple_size_s';

const props: CreateIconArguments = {
  l: IconPolygonPurpleSizeS,
  m: IconPolygonPurpleSizeS,
  s: IconPolygonPurpleSizeS,
  xs: IconPolygonPurpleSizeS,
  name: 'IconPolygonPurple',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
